import api from '../configs/api';

const UserServices = {
    users: (pageNumber: number) =>
        api.get('users', { params: { subscription: true /*, suspended: true*/, page: pageNumber, size: 10 } }),
    createUser: (newUser: any) => {
        //TODO: isMonthly should be conditional
        newUser = { ...newUser, isMonthly: true };
        var formData = new FormData();

        for (let key in newUser) {
            formData.append(key, newUser[key]);
        }
        return api.post('users', formData, {
            headers: {
                'content-type': 'multipart/form-data'
            }
        });
    },
    getUser: (id: any) => api.get(`users/${id}`),
    checkEmail: (email: string) => api.get(`/users/exists/email?emailId=${email}`),
    updateUser: (id: any, updatedUser: any) => {
        updatedUser = { ...updatedUser, isMonthly: true };
        let formData = new FormData();

        for (let key in updatedUser) {
            formData.append(key, updatedUser[key]);
        }

        return api.put(`users/${id}`, formData, {
            headers: {
                'content-type': 'multipart/form-data'
            }
        });
    },
    delete: (id: number) => api.delete(`users/${id}`),
    suspend: (id: number, state: boolean) => api.put(`users/${id}/suspend?state=${state}`),
    getAllTimezones: () => api.get('users/all/timezone')
};
export default UserServices;
